<template>
  <div class="container">
    <div class="image-wrapper">
      <!--<i class="el-icon-success icon" v-if="!!image.class_id"></i>-->
      <div class="btn-wrapper">
        <el-popover
          ref="popover1"
          placement="top-start"
          trigger="click">
          <span>
            <img :src="image.dish_img_url" alt="" width="150px">
            <div class="check-text" v-if="image.checkText">{{image.checkText}}</div>
          </span>
          <el-button type="text" class="btn" icon="el-icon-search" slot="reference"></el-button>
        </el-popover>
        <!--<el-button type="text" v-if="deleteShow" class="btn danger-text" icon="el-icon-delete"-->
                   <!--@click="handleDelete"></el-button>-->
      </div>
      <div class="mask-wrapper" @mouseenter="imageOnHover" @mouseleave="imageOnBlur">
        <!--<el-tag type="danger" v-if="image.checkText">{{image.checkText}}</el-tag>-->
        <span class="check-text" v-if="image.checkText">{{image.checkText}}</span>
        <i v-if="iconShow && !!image.class_id && deleteShow" class="el-icon-delete el-icon-check icon-btn"
           @click="handleUnmark"></i>
      </div>
      <img
        v-lazy="image.dish_img_url"
        class="image-item"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'imageItem',
  components: {

  },
  props: {
    optionShow: true,
    image: {
      type: Object,
      default () {
        return {};
      }
    },
    selfCheck: false,
    dish_img_uuid: '',
    modelList: {
      type: Array,
      default () {
        return [];
      }
    }

  },
  data () {
    return {
      iconShow: false
    };
  },
  mounted () {

  },
  methods: {
    handleDelete () {
      this.$confirm('是否删除此图片?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.$emit('delete', {dish_img_uuid: this.dish_img_uuid});
        this.$message({
          type: 'success',
          message: '删除成功'
        });
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '您已取消删除'
        });
      });
    },
    imageOnHover () {
      this.iconShow = true;
    },
    imageOnBlur () {
      this.iconShow = false;
    },
    handleUnmark () {
      this.$emit('unMark', {dish_img_uuid: this.dish_img_uuid, class_id: this.image.class_id});
    },
    handleMark () {
      setTimeout(() => {
        this.$emit('mark', this.dish_img_uuid);
      }, 200);
    }
  },
  computed: {
    selfChecked () {
      return this.$route.query.selfCheck;
    },
    deleteShow () {
      return this.$router.currentRoute.name === 'checkProcess' && this.selfCheck === true;
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    margin-bottom: 10px;
    .image-wrapper {
      vertical-align: top;
      position: relative;
      width: 80px;
      height: 80px;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .btn-wrapper {
        position: absolute;
        right: 0px;
        width: 30px;
        z-index: 100;
        text-align: center;
        .btn {
          padding: 0;
          margin: 5px 0 ;
        }
      }
      position: relative;
      display: inline-block;
      text-align: center;
      .icon {
        position: absolute;
        top: 0;
        right: 0;
        color: #13ce66;
        font-size: 30px;
        background-color: #fff;
        border-radius: 50%;
      }
      .mask-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        line-height: 100px;
        cursor: move;
        text-align: center;
        .check-text {
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          width: 70px;
          height: 20px;
          line-height: 20px;
          display: inline-block;
          font-size: 16px;
          padding: 5px;
          border-radius: 10px;
          color: #ccc;
          background-color:rgba(0, 0, 0, 0.5);
        }
        .icon-btn {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          line-height: 80px;
          text-align: center;
          font-size: 26px;
          font-weight: bold;
          color: #fff;
          &.el-icon-circle-plus-outline {
            color: #00ff00;
          }
          &.el-icon-delete {
            color: #ff0000;
          }
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

    }
  }
</style>
